module.exports = __webpack_public_path__ + "media/images/pc/top/kodawari_photowedding@2x-7efd4e42fe8a36dcc27d9fc5fded5f4f.webp";